import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// The "Propertywise Comm % (Optional)" side panel from the legacy screen: every
// property listed, a "Contains" filter on the name, and an editable % per row.
// The parent (agentMasterForm.js) owns the percentage values (keyed by
// propertyId) so it can build the propertyPercentages[] payload at save time.
const AgentPropertyPercent = ({ properties, percentageMap, onChangePercentage, readOnly = false }) => {
  const { t } = useTranslation();
  const [filterText, setFilterText] = useState('');

  const filteredProperties = useMemo(() => {
    if (!filterText.trim()) return properties || [];
    const needle = filterText.trim().toLowerCase();
    return (properties || []).filter((item) => String(item?.text ?? item?.label ?? '').toLowerCase().includes(needle));
  }, [properties, filterText]);

  return (
    <div className="border-box2 p-2" style={{ borderRadius: '8px', height: '100%' }}>
      <div className="text-muted small mb-2">{t('agentMaster.fields.propertyPercentTitle')}</div>
      <div className="table-container" style={{ overflowY: 'auto', maxHeight: '440px' }}>
        <table className="table table-bordered gridshad mb-0">
          <thead className="dynoTable">
            <tr>
              <th>{t('agentMaster.fields.propertyName')}</th>
              <th style={{ width: '90px' }}>{t('agentMaster.fields.commPercent')}</th>
            </tr>
            <tr>
              <th>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder={t('common.contains')}
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filteredProperties.map((item) => {
              const propertyId = String(item?.value ?? item?.propertyNo ?? '');
              const propertyName = item?.text ?? item?.label ?? '';
              const percentage = percentageMap?.[propertyId]?.percentage ?? 0;
              return (
                <tr key={propertyId || propertyName}>
                  <td>{propertyName}</td>
                  <td>
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="0.01"
                      className="form-control form-control-sm text-end"
                      value={percentage}
                      disabled={readOnly}
                      onChange={(e) => onChangePercentage(propertyId, propertyName, e.target.value)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AgentPropertyPercent;
